import { bindRequestLogic } from './utils'
import LogRoutineTypes from '../actionTypes/logRoutine'
import { logRoutineAPI } from '../api'

const getLogRoutines = bindRequestLogic({
  clientFunc: logRoutineAPI.getLogRoutines,
  type: LogRoutineTypes.GET_LOG_ROUTINES_REQUEST,
  successType: LogRoutineTypes.GET_LOG_ROUTINES_SUCCESS,
  failType: LogRoutineTypes.GET_LOG_ROUTINES_FAILED,
  isQueryParam: true,
  modelName: 'logRoutines'
})

const getCodeRoutines = bindRequestLogic({
  clientFunc: logRoutineAPI.getCodeRoutines,
  type: LogRoutineTypes.GET_CODE_ROUTINES_REQUEST,
  successType: LogRoutineTypes.GET_CODE_ROUTINES_SUCCESS,
  failType: LogRoutineTypes.GET_CODE_ROUTINES_FAILED,
  modelName: 'codeRoutines'
})

export default [getLogRoutines, getCodeRoutines]
